import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { QuoteRouteV2Id } from 'routes/routesConfigV2';
import QuoteFlowLayout from 'components/common/quote/QuoteFlowLayout';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';
import AltusProposalInfoForm from 'components/quote/quote-proposal-info/Altus';
import AltusQuoteProposalInfoPageStore, {
  AltusQuoteProposalInfoPageStoreContext,
  useAltusQuoteProposalInfoPageStore,
} from 'store/pages/quote/quote-proposal-info/altus/pageStore';

// TESTING_POLICY: CYPRESS_ONLY

const PageContent: React.FC = observer(() => {
  const { flowDelegate, canCompleteStep, isActionLoading, getInitialData, onComplete } =
    useAltusQuoteProposalInfoPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <QuoteFlowLayout
      flowDelegate={flowDelegate}
      pageId={QuoteRouteV2Id.QUOTE_PROPOSAL_INFO}
      isPageLoading={flowDelegate.isInitialDataLoading}
      isActionLoading={isActionLoading}
      pageHeader={{ subtitleMaxWidth: '50rem' }}
      pageFooter={{
        onComplete,
        completeButtonText: 'Save',
        disableCompleteButton: !canCompleteStep,
      }}
    >
      <AltusProposalInfoForm />
    </QuoteFlowLayout>
  );
});

const AltusQuoteProposalInfoPage: React.FC = () => {
  const { groupId, periodId, cartId } = useQuoteDomainParams();

  const pageStore = useMemo(
    () => new AltusQuoteProposalInfoPageStore({ groupId, periodId, cartId }),
    [groupId, periodId, cartId],
  );

  return (
    <AltusQuoteProposalInfoPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </AltusQuoteProposalInfoPageStoreContext.Provider>
  );
};

export default AltusQuoteProposalInfoPage;
